import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { CreateModal } from "../../../shared/components/Modal";
import { useGetNotaFiscal } from "../hooks/useGetNotasFiscais";
import usePutNotaFiscal from "../hooks/usePutNotaFiscal";
import { NotaFiscalProps } from "../types";
import { FormModalNotaFiscal } from "./FormModalNotaFiscal";

interface EditNotaFiscalModalProps {
  onCancel: () => void;
  deleteModal: () => void;
  visible: boolean;
  notaFiscalId: number;
}

export function EditNotaFiscalModal({
  onCancel,
  deleteModal,
  visible,
  notaFiscalId: id,
}: EditNotaFiscalModalProps) {
  const { register, handleSubmit, reset, setValue, control, formState: {errors} } =
    useForm<NotaFiscalProps>();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [notaFiscal, setNotaFiscal] = useState<NotaFiscalProps>();
  const { data: notaFiscalData } = useGetNotaFiscal(id)

  const { mutate: salvarEdicaoNotaFiscal, isLoading: LoadingButton} = usePutNotaFiscal(() => handleCloseLaterSave());

  useEffect(() => {
    notaFiscalData && setNotaFiscal(notaFiscalData);
  }, [notaFiscalData]);

  useEffect(() => {
    reset({ 
      ...notaFiscalData, 
      NotaFiscalData: moment(notaFiscalData?.NotaFiscalData).utc(false).format("YYYY-MM-DD"),
      ComissaoPorcentagem: notaFiscalData?.ComissaoPorcentagem
      ? notaFiscalData?.ComissaoPorcentagem * 100
      : 0,
    });
  }, [notaFiscalData, reset]);

  async function onSubmit(data: NotaFiscalProps) {
    const formattedData = {
      ...data,
      NotaFiscalData: data.NotaFiscalData.split("/").reverse().join("-"),
      ComissaoPorcentagem: data.ComissaoPorcentagem
      ? data.ComissaoPorcentagem / 100
      : 0,
    };
    
    navigator.onLine &&
      await salvarEdicaoNotaFiscal({
        notaFiscalAtual: notaFiscal ? notaFiscal : notaFiscalData,
        id,
        data: formattedData,
      });
      
    if(!navigator.onLine) {
      Swal.fire({
        title: 'Sem conexão',
        text: 'Por favor, verifique a sua conexão com a internet e tente novamente.',
        icon: 'error',
        position: 'center',
        confirmButtonText: 'OK',
        confirmButtonColor: '#f27474'
      })
    }
    
  }

  function handleCloseLaterSave() {
    onCancel();
    reset();
    setDisabled(!disabled);
  }

  return (
    <>
      <CreateModal
        title="Editar Nota Fiscal"
        isModalOpen={visible}
        disabled={disabled}
        onCancel={onCancel}
        isLoading={LoadingButton}
        onSubmit={handleSubmit(onSubmit)}
        deleteOpenModal={() => {
          deleteModal();
        }}
        setDisabled={() => setDisabled(!disabled)}
        closable
        hasId
      >
        {notaFiscal && (
          <FormModalNotaFiscal
            register={register}
            notaFiscal={notaFiscalData}
            setValue={setValue}
            disabled={disabled}
            control={control}
            errors={errors}
            formEdit
          />
        )}
      </CreateModal>
    </>
  );
}
